const global = window

inputs.fn.paramedit = {
    // JSON -> array
    applyJson(input, form, exclude) {
        if (input.data('lock-pe')) return false;
        input.data('lock-pe', true);

    	if (!exclude) exclude = [];
        exclude.push(input.attr('name'));

        var inputJson = $(input).val();

        if (inputJson) {
            try {
                var json = JSON.parse(inputJson);
                inputs.fn.paramedit.applyData(json, form, null, exclude);
            }
            catch (e) {
                /*
                $('.tabs[name=tabs-inputEdit]').tabs('option', 'active', $('.tabs[name=tabs-inputEdit] > ul > li').length-1);
                $('.tabs[name=tabs-inputEdit]').tabs('disable');
                $('.tabs[name=tabs-inputEdit]').tabs('enable', $('.tabs[name=tabs-inputEdit] > ul > li').length-1);
                $('#'+prefix+'scriptError').fadeIn();
                */
                console.log('Impossible de décoder les paramètres');
                console.log(inputJson);
                // Continue processing instead of returning false
            }
        }

        input.removeData('lock-pe');
    },

    // JSON -> field values
    applyData(data, form, prefix, exclude) {
        if (!prefix) prefix = '';
    	if (!exclude) exclude = [];
        if (typeof data != 'object') return false;
        $.each(data, function (name) {
        	if (exclude.indexOf(name) == -1) {
                var subdata = this;
                var field = $(form).find('[name="' + prefix + name + '"]').filter('select, input, textarea');
                if (field.length) {
                    var value = null;
                    let currentFormat = field.data('format');

                    if (currentFormat == 'conds' && calculateDepth(subdata) < 3) {
                        currentFormat = 'items';
                    }

                    switch (currentFormat) {
                        case 'conds':
                            var separator = (field.data('separator')) ? field.data('separator') : ' : ';
                            var itemsRaw = subdata;
                            var items = [];
                            if (itemsRaw && typeof itemsRaw != 'string') {
                                $.each(itemsRaw, function () {
                                    var subitems = [];
                                    $.each(this, function () {
                                        subitems.push(this.join(separator));
                                    })
                                    items.push(subitems.join("\n"));
                                })
                            }
                            value = items.join("\n\n");
                            break;
                        case 'items':
                            var separator = (field.data('separator')) ? field.data('separator') : ' : ';
                            var itemsRaw = subdata;
                            var items = [];
                            if (itemsRaw && typeof itemsRaw != 'string' && Array.isArray(itemsRaw)) {
                                $.each(itemsRaw, function () {
                                    if (Array.isArray(this)) {
                                        items.push(this.join(separator));
                                    } else {
                                        items.push(String(this));
                                    }
                                })
                            }
                            value = items.join("\n");
                            break;
                        case 'enum':
                            var items = subdata;
                            if (Array.isArray(items)) {
                                value = items.join(",");
                            } else {
                                value = String(subdata);
                            }
                            break;
                        case 'json':
                            try {
                                var dataJson = JSON.stringify(subdata);
                            } catch (e) {
                                var dataJson = '[]';
                            }
                            value = String(dataJson);
                            break;
                        default:
                            value = String(subdata);
                    }
                    // Checkbox
                    if (field.attr('type') == 'checkbox') {
                        if (parseInt(value)) field.attr('checked', 'checked').change();
                        else field.removeAttr('checked').change();
                    }
                    // Others
                    else if (field && (value || value === 0)) {
                        try {
                            field.val(value);
                            if (field.prop("tagName") == 'SELECT') {
                                var existingOption = field.find('option[value="' + value + '"]');
                                if (!existingOption.length && value != 'null') {
                                    var newOption = new Option(value, value, false, false);
                                    $(newOption).data('img', value);
                                    field.append(newOption).val(value);
                                }
                            }
                            field.change();
                        } catch (error) {

                        }
                    }
                } else if (subdata && typeof subdata == 'object' && subdata != subdata.self && name && name != 'window' && name != 'document' && name != 'self' && typeof name != 'number' && name != 'dataClean') {
                    // console.log('SUB-----------');
                    if (inputs.fn.paramedit.applyData)
                        inputs.fn.paramedit.applyData(subdata, form, prefix + name + '.', exclude);
                }
            }
        });
    },

    // Field value -> Json
    generateJson(input, form, currentField, exclude) {
        input = $(input)
        if (input.data('lock-pe')) return false;
        input.data('lock-pe', true);

        if (!exclude) exclude = [];
        exclude.push(input.attr('name'));

        if (exclude.indexOf($(currentField).attr('name')) == -1) {
            input.val(JSON.stringify(inputs.fn.paramedit.generateData(form, exclude, input), null, "\t"))
            input.change();
            input.removeData('skipGen');
        }

        input.removeData('lock-pe');
    },

    // Convert flat keys with dots to nested objects
    flattenToNested(data) {
        var result = {};
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var keys = key.split('.');
                var current = result;
                for (var i = 0; i < keys.length; i++) {
                    if (i === keys.length - 1) {
                        current[keys[i]] = data[key];
                    } else {
                        if (!current[keys[i]]) {
                            current[keys[i]] = {};
                        }
                        current = current[keys[i]];
                    }
                }
            }
        }
        return result;
    },

    generateData(form, exclude, input) {
        var data = {};
        data = getFormData(form, true, exclude)

        // Traitement de l'option discard sur les champs
        $(form).find('input, select, textarea').each(function() {
            var el = $(this);
            var name = el.attr('name');
            if (name && data.hasOwnProperty(name)) {
                var fieldData = el.data('data');
                if (fieldData && fieldData.discard !== undefined) {
                    var discardVal = fieldData.discard;
                    var currentValue = data[name];
                    var shouldDiscard = false;

                    // Fonction utilitaire pour comparer en ignorant le type (string vs number) et en supportant les arrays vides
                    var isEqual = function(a, b) {
                        // Cas array vide : [] dans discard ou currentValue vide
                        var isArrayEmpty = function(val) {
                            return (Array.isArray(val) && val.length === 0) || val === '[]';
                        };
                        if (isArrayEmpty(b)) {
                            return isArrayEmpty(a);
                        }

                        // Si les deux sont des nombres ou des strings contenant des nombres
                        if ((typeof a === 'number' || typeof a === 'string') &&
                            (typeof b === 'number' || typeof b === 'string')) {
                            return a == b; // Comparaison faible qui accepte 1 == "1"
                        }
                        return a === b; // Comparaison stricte pour les autres types
                    };

                    if (Array.isArray(discardVal)) {
                        // Si discardVal est lui-même un array vide []
                        if (discardVal.length === 0) {
                            if (Array.isArray(currentValue) && currentValue.length === 0) {
                                shouldDiscard = true;
                            }
                        } else {
                            for (var i = 0; i < discardVal.length; i++) {
                                if (isEqual(currentValue, discardVal[i])) {
                                    shouldDiscard = true;
                                    break;
                                }
                            }
                        }
                    } else {
                        if (isEqual(currentValue, discardVal)) {
                            shouldDiscard = true;
                        }
                    }

                    if (shouldDiscard) {
                        delete data[name];
                    }
                }
            }

            // Convert string values to numbers if input field is numeric or if original JSON value was a number
            if (name && data.hasOwnProperty(name)) {
                var val = data[name];
                if (typeof val === 'string' && val.trim() !== '') {
                    var inputType = el.attr('type');
                    var isNumericInput = inputType === 'number' || el.hasClass('field--number') || el.data('format') === 'number' || el.data('format') === 'int' || el.data('format') === 'float';
                    
                    if (isNumericInput && !isNaN(val)) {
                        data[name] = Number(val);
                    }
                }
            }
        });

        data = inputs.fn.paramedit.flattenToNested(data);

        if (input && $(input).length) {
            var inputJson = $(input).val();
            if (inputJson) {
                try {
                    var origJson = JSON.parse(inputJson);
                    if (origJson && typeof origJson === 'object' && !Array.isArray(origJson)) {
                        // Collecter tous les noms de champs présents dans le formulaire
                        var formFieldNames = {};
                        $(form).find('input, select, textarea').each(function() {
                            var n = $(this).attr('name');
                            if (n) {
                                formFieldNames[n] = true;
                                // Si c'est imbriqué, marquer également la clé racine
                                var rootKey = n.split('.')[0];
                                formFieldNames[rootKey] = true;
                            }
                        });

                        // Préserver les propriétés racine d'origine uniquement si elles ne proviennent pas d'un champ du formulaire
                        for (var key in origJson) {
                            if (origJson.hasOwnProperty(key) && !data.hasOwnProperty(key) && !formFieldNames.hasOwnProperty(key)) {
                                data[key] = origJson[key];
                            }
                        }

                        // Conserver les types numériques d'origine pour les champs correspondants
                        var restoreTypes = function(targetObj, sourceObj) {
                            for (var k in targetObj) {
                                if (targetObj.hasOwnProperty(k) && sourceObj.hasOwnProperty(k)) {
                                    if (typeof sourceObj[k] === 'number' && typeof targetObj[k] === 'string' && targetObj[k].trim() !== '' && !isNaN(targetObj[k])) {
                                        targetObj[k] = Number(targetObj[k]);
                                    } else if (typeof targetObj[k] === 'object' && targetObj[k] !== null && typeof sourceObj[k] === 'object' && sourceObj[k] !== null) {
                                        restoreTypes(targetObj[k], sourceObj[k]);
                                    }
                                }
                            }
                        };
                        restoreTypes(data, origJson);
                    }
                } catch (e) {}
            }
        }

        return data;
    },

    virtualForm(grid, element, form) {
        var gridInstance = (grid && grid.element) ? grid : (grid && grid.data ? (grid.data('plugin') || grid) : grid);
        var isItem = element && $(element).length && $(element).hasClass('iv__item');
        var itemData = isItem ? $(element).data('data') : (element && !$(element).hasClass('iconGrid') ? $(element).data('data') : null);
        var json = (itemData && itemData.dataClean !== undefined) ? itemData.dataClean : (itemData || {});
        var currentElementPath = isItem ? $(element).data('path') : null;
        var currentElementGrid = gridInstance;

        var subformContainer = form && $(form).length ? $(form) : null;
        if (!subformContainer || !subformContainer.find('.subform__content').length) {
            if (element && $(element).closest('.repeater').find('.subform').length) {
                subformContainer = $(element).closest('.repeater').find('.subform');
            } else if (gridInstance && gridInstance.element && $(gridInstance.element).closest('.repeater').find('.subform').length) {
                subformContainer = $(gridInstance.element).closest('.repeater').find('.subform');
            }
        }

        if (!subformContainer || !subformContainer.find('.subform__content').length) {
            console.error('Subform template not found');
            return;
        }

        var currentFormHtml = subformContainer.find('.subform__content').html();
        currentFormHtml = b64DecodeUnicode(currentFormHtml.trim());
        var currentForm = $(currentFormHtml);

        var contentSection = currentForm.is('section') ? currentForm : currentForm.find('section');
        var icon = contentSection.data('icon') || (element && $(element).data('icon')) || (gridInstance && gridInstance.conf && gridInstance.conf.default && gridInstance.conf.default.icon) || 'tool-pencil';
        var width = contentSection.data('width') || 1000;
        var height = contentSection.data('height') || '90%';
        var title = (isItem && $(element).data('label')) || (json && (json.label || json.name || json.title || json.titre)) || (isItem ? 'Modifier un élément' : 'Ajouter un élément');

        var currentWindow = $.window({
            id: 'subdataEdit_' + Math.random().toString(36).substring(2, 9),
            title: title,
            icon: icon,
            content: currentForm,
            maxWidth: -1,		  // the minimum width, if -1 means no checking
            maxHeight: -1,		 // the minimum height, if -1 means no checking
            showFooter: false,
            maximizable: false,
            closable: true,
            showModal: true,
            width: width,
            height: height,
            checkBoundary: true,
            onShow: function () {
                eval(this.content.find('script').text());
                if (typeof BEHAV !== 'undefined' && BEHAV) {
                    BEHAV.apply(this.content);
                }
            },
            onClose: function () {
                if (typeof BEHAV !== 'undefined' && BEHAV) {
                    BEHAV.apply(this.content, 'unload');
                }
            }
        });

        var currentContainer = currentWindow.getContainer();
        if (json && Object.keys(json).length > 0) {
            inputs.fn.paramedit.applyData(json, currentContainer);
        }

        currentContainer.find('.btn--close').click(function(e) {
            e.preventDefault();
            closeWindow(this);
        });

        currentContainer.find('.btn--submit').click(function(e) {
            e.preventDefault();
            let currentElementData = inputs.fn.paramedit.generateData(currentContainer);
            if (currentElementPath !== null && currentElementPath !== undefined) {
                currentElementGrid.update(currentElementData, currentElementPath);
            } else {
                currentElementGrid.add(currentElementData, []);
            }
            currentElementGrid.save();
            closeWindow(this);
        });
    },

    // Bind fields edit --> json
    bind(target, codeInput, form, exclude) {
        const _codeInput = codeInput
        target.find('input, textarea, select').change(function(event) {
            inputs.fn.paramedit.generateJson(_codeInput, form, $(this), exclude);
        });
    }
}

// Remplissage automatique
inputs.behavior.paramedit = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.paramedit) {
        const form = input.closest('form');
        const exclude = data.paramedit.exclusions;
        exclude.push(input.attr('name'));
        input.removeData('lock-pe');

        inputs.fn.paramedit.bind(inputWindow, input, form, exclude);
        const _input = input
        BEHAV.add(inputs.fn.paramedit.bind, inputWindow.data('behavkey'), [_input, form, exclude]);

        // Bind json edit ---> fields
        input.change(function() {
			inputs.fn.paramedit.applyJson(_input, form, exclude);
		});
        inputs.fn.paramedit.applyJson(_input, form, exclude);
    }
    return data
}
